import extend from '@/utils/vuex-extend';
import { dialog } from '@/vuex-extend';
import { wait } from '@/utils/wait';
import {listShop} from "@/api/oms/shopee-order";

export default extend(dialog, {
	namespaced: true,
	state: {
		form: {},
	},
	actions: {
		async afterOpenDialog({ dispatch, commit }, payload) {
			// await wait(dispatch, 'sms.forwarding-order.import-order', async function() {
			//
			// })
		}
	}
})



// WEBPACK FOOTER //
// ./src/store/modules/sms/forwarding-order/import-order.js